export function compareNaturalStrings(
  left: string | null | undefined,
  right: string | null | undefined,
): number {
  return (left || '').localeCompare(right || '', undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}

export function sortByNaturalString<T>(
  items: T[],
  getValue: (item: T) => string | null | undefined,
): T[] {
  return [...items].sort((left, right) =>
    compareNaturalStrings(getValue(left), getValue(right)),
  );
}
